import {DELETE_RELATION_URL, INVITE_URL, RELATIVES_URL} from "../constants/api";
import {RELATIVES_ADD, RELATIVES_FETCH} from "../constants/actionTypes";
import relativeImage from '../../../../assets/img/relatives_211x211.png';
import {RC_USER_PREFIX_FP} from "../../../shared/modules/rocketChat/constants";
import {TYPE_RELATIVE} from "../constants";
import {requestAuth} from "../../../request";
import { setMixPanelUserInfo } from "../../../shared/actions/analytics";

/**
 * Gets relative by it`s identification
 * @param {string} id - relative identification
 * @returns {function(dispatch, getState)} thunk to be dispatched
 */
export function getRelative(id) {
  return (dispatch, getState) => {
    return getState().relatives.find((relative) => {
      return relative.prof_id.toString() === id;
    })
  };
}

/**
 * Relatives relatives fetched successfully
 * @param {array} relatives - fetched relatives
 * @returns {{type: string, payload: Array}} member fetch relatives action
 */
export function fetchAction(relatives) {
  if (relatives) {
    setMixPanelUserInfo({'amountRelatives': relatives.length});
  }
  return {
    type: RELATIVES_FETCH,
    payload: relatives.map((relative) => {
      return {
        type: TYPE_RELATIVE,
        prof_id: relative.prof_id,
        firstname: relative.firstname || relative.prename || "",
        lastname: relative.lastname,
        username: RC_USER_PREFIX_FP + relative.prof_id,
        imgUrl: relativeImage,
        email: relative.email
      }
    })
  };
}

/**
 * Checks whether relative is inside of fetched relatives list
 * @param {object} relative - relative object {email, firstname, lastname, ...}
 * @returns {function(dispatch, getState): boolean} thunk to be dispatched
 */
 export function has(relative) {
   return (dispatch, getState) => {
     const {relatives} = getState();

     return relatives.some((relativesItem) => {
       return Object.keys(relative).reduce((result, currentKey) => {
        return result && relativesItem[currentKey] === relative[currentKey];
       }, relatives.length);
     })
   };
 }

/**
 * Invites a relative
 * @param {object} relative - relative data
 * @returns {function(dispatch): Promise<any>} promised thunk
 */
export function inviteRelative(relative) {
  return (dispatch) => {
    return requestAuth()
      .post(INVITE_URL)
      .type("form")
      .send({
        data_json: JSON.stringify([
          {
            firstname: relative.firstname,
            lastname: relative.lastname,
            inv_mail: relative.email
          }
        ]),
        portal: true,
        profile_id: relative.prof_id
      })
      .then(() => dispatch(
        {
          type: RELATIVES_ADD,
          payload: {
            email: relative.email,
            firstname: relative.firstname,
            lastname: relative.lastname,
            prof_id: relative.prof_id,
            type: TYPE_RELATIVE
          }
        }
      ));
  };
}

/**
 * Deletes a relation with a Senior
 * @param {object} senior - senior concerned by the deletion
 * @param {object} relative - logged in relative
 * @returns {Promise<string>} a promise with senior
 */
export function deleteRelation(senior, relative) {
  return requestAuth()
    .delete(DELETE_RELATION_URL)
    .type("form")
    .send({
      data_json: JSON.stringify([
        {
          relative_email: relative.email,
          prof_id: senior.prof_id,
          origin: "family_portal"
        }
      ])
    })
    .then(() => senior);
}


/**
 * Gets list of relatives
 * @param {array} seniors - list of seniors
 * @returns {function(dispatch, getState): Promise<any>} promised thunk to be dispatched
 */
export function getRelatives(seniors) {
  return (dispatch, getState) => {
    if (getState().relatives.length > 0) {
      setMixPanelUserInfo({'amountRelatives': getState().relatives.length});
      return Promise.resolve(getState().relatives);
    } else if (seniors) {
      return requestAuth()
        .post(RELATIVES_URL)
        .type("application/json")
        .send(
          JSON.stringify(
            {
              "prof_id": seniors.reduce((list, item) => {
                list.push(item.prof_id);
                return list;
              }, [])
            }
          )
        )
        .then((res) => dispatch(fetchAction(res.body)).payload);
    }
  };
}

/**
 * Replaces Email Provider
 * @param {string} email - relative's email
 * @returns {string} new email - email without provider domain
 */
export function maskEmailProvider(email) {
  const regex = /@.+/;

  return email.replace(regex, '@***');
}
